<div
  class="am-toast"
  *ngIf="showToast"
  [ngClass]="{
    'am-toast--success': type === 'success',
    'am-toast--error': type === 'error',
    'am-toast--info': type === 'info',
    'am-toast--enter': !dismissing,
    'am-toast--exit': dismissing
  }"
  role="alert"
  aria-live="polite"
>
  <span class="am-toast__message">{{ message }}</span>
</div>
